import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FooterLinks } from '@shared/constants/footer-links';
import { FooterLink } from 'src/app/modules/auth/abstractions/footer-link';

@Component({
  standalone: false,
  selector: 'gstar-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  footerLinks: FooterLink[] = FooterLinks;
  showDisclaimer: boolean = false;
  currentYear = new Date().getFullYear();

  clickDisclaimer(): void {
    this.showDisclaimer = true;
  }
}
